module.exports = __webpack_public_path__ + "static/media/persona.81e744af.jpeg";